/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaskphoto3Inputs */

const en_aiflowaskphoto3 = /** @type {(inputs: Aiflowaskphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag your photo here or paste it with Ctrl+V. We set text and logo ourselves, the photo is not sent to any AI.`)
};

const de_aiflowaskphoto3 = /** @type {(inputs: Aiflowaskphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieh dein Foto hierher oder füg es mit Strg+V ein. Text und Logo setzen wir selbst drauf, das Foto geht an keine KI.`)
};

/**
* | output |
* | --- |
* | "Drag your photo here or paste it with Ctrl+V. We set text and logo ourselves, the photo is not sent to any AI." |
*
* @param {Aiflowaskphoto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskphoto3 = /** @type {((inputs?: Aiflowaskphoto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskphoto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskphoto3(inputs)
	return de_aiflowaskphoto3(inputs)
});
export { aiflowaskphoto3 as "aiFlowAskPhoto" }